import React from 'react';
import './Services.css';
import ServicesBannerCarousel from '../ServicesBannerCarousel/ServicesBannerCarousel';
import image31 from '../img/img-31.jpg';
import image32 from '../img/img-32.jpg';
import image33 from '../img/img-33.avif';
import image34 from '../img/img-34.jpg';
import image54 from '../img/img-54.jpg';
import image55 from '../img/img-55.jpg';
import image56 from '../img/img-56.jpg';
import image57 from '../img/img-57.jpg';
import image58 from '../img/img-58.jpg';
import image59 from '../img/img-59.jpg';
import image60 from '../img/img-60.jpg';
import image61 from '../img/img-61.jpg';
import image63 from '../img/img-63.jpg'
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

const Services: React.FC = () => {
    return (
        <div className="body">
            <Header onSearchClick={() => {}} /> 

            <ServicesBannerCarousel />

            {/* New Services Section */}
            <div className="parent-container43">
                <div className="info30">
                    <h2>Our Extended Services</h2>
                    <p className="services-intro">Beyond matchmaking, we offer comprehensive life enhancement services to support your journey towards success and fulfillment.</p>
                </div>

                <div className="services-grid">
                    
                   {/* IELTS Training */}
                    <div className="service-card">
                        <div className="service-icon">
                            <img src={image56} alt="IELTS Training" />
                        </div>
                        <div className="service-content">
                            <h3>IELTS Training</h3>
                            <p>Comprehensive IELTS preparation to achieve your target scores.</p>
                            <ul className="service-points">
                                <li>Expert-led training sessions</li>
                                <li>Practice tests and mock exams</li>
                                <li>Speaking and writing workshops</li>
                                <li>Personalized study plans</li>
                                <li>Score improvement guarantee</li>
                            </ul>
                        </div>
                    </div>

                    {/* Recruitment Abroad */}
                    <div className="service-card">
                        <div className="service-icon">
                            <img src={image55} alt="Recruitment Abroad" />
                        </div>
                        <div className="service-content">
                            <h3>Recruitment Abroad</h3>
                            <p>Specialized recruitment services for overseas employment opportunities.</p>
                            <ul className="service-points">
                                <li>Visa assistance and documentation</li>
                                <li>Pre-departure orientation programs</li>
                                <li>Partner with international employers</li>
                                <li>Legal compliance and work permits</li>
                                <li>Post-placement support services</li>
                            </ul>
                        </div>
                    </div>

                     {/* Job Opportunities */}
                    <div className="service-card">
                        <div className="service-icon">
                            <img src={image54} alt="Job Opportunities" />
                        </div>
                        <div className="service-content">
                            <h3>Job Opportunities</h3>
                            <p>Connect with global career opportunities and build your professional future.</p>
                            <ul className="service-points">
                                <li>International job placements</li>
                                <li>Career guidance and counseling</li>
                                <li>Resume building and optimization</li>
                                <li>Professional networking opportunities</li>
                                <li>Industry-specific job matching</li>
                            </ul>
                        </div>
                    </div>

                    

                    {/* OET Training */}
                    <div className="service-card">
                        <div className="service-icon">
                            <img src={image57} alt="OET Training" />
                        </div>
                        <div className="service-content">
                            <h3>OET Training</h3>
                            <p>Specialized Occupational English Test preparation for healthcare professionals.</p>
                            <ul className="service-points">
                                <li>Healthcare-specific English training</li>
                                <li>Medical terminology workshops</li>
                                <li>Clinical scenario practice</li>
                                <li>Professional communication skills</li>
                                <li>Industry-recognized certification</li>
                            </ul>
                        </div>
                    </div>

                    {/* Mock Interviews */}
                    <div className="service-card">
                        <div className="service-icon">
                            <img src={image58} alt="Mock Interviews" />
                        </div>
                        <div className="service-content">
                            <h3>Mock Interviews & Tips</h3>
                            <p>Professional interview preparation to boost your confidence and success rate.</p>
                            <ul className="service-points">
                                <li>One-on-one mock interview sessions</li>
                                <li>Industry-specific interview preparation</li>
                                <li>Body language and presentation coaching</li>
                                <li>Common questions and best practices</li>
                                <li>Feedback and improvement strategies</li>
                            </ul>
                        </div>
                    </div>

                    {/* Supported Accommodation */}
                    <div className="service-card">
                        <div className="service-icon">
                            <img src={image59} alt="Supported Accommodation" />
                        </div>
                        <div className="service-content">
                            <h3>Supported Accommodation</h3>
                            <p>Assisted housing solutions for those who need additional support.</p>
                            <ul className="service-points">
                                <li>24/7 support staff availability</li>
                                <li>Safe and secure living environments</li>
                                <li>Life skills development programs</li>
                                <li>Mental health and wellness support</li>
                                <li>Community integration assistance</li>
                            </ul>
                        </div>
                    </div>

                    {/* Free Housing */}
                    <div className="service-card">
                        <div className="service-icon">
                            <img src={image60} alt="Free Housing" />
                        </div>
                        <div className="service-content">
                            <h3>Free Housing for Qualified</h3>
                            <p>Complimentary housing solutions for eligible candidates meeting our criteria.</p>
                            <ul className="service-points">
                                <li>Qualification assessment process</li>
                                <li>Fully furnished accommodations</li>
                                <li>Utilities and maintenance included</li>
                                <li>Community living opportunities</li>
                                <li>Pathway to independent living</li>
                            </ul>
                        </div>
                    </div>

                    {/* Feeding the Hungry */}
                    <div className="service-card">
                        <div className="service-icon">
                            <img src={image61} alt="Feeding the Hungry" />
                        </div>
                        <div className="service-content">
                            <h3>Feeding the Hungry</h3>
                            <p>Community food support program provided through HomeCookt, our dedicated food service project. Terms and conditions applied.</p>
                            <ul className="service-points">
                                <li>Daily meal distribution programs</li>
                                <li>Nutritious and balanced meals</li>
                                <li>Community kitchen facilities</li>
                                <li>Food voucher assistance</li>
                                <li>Eligibility criteria assessment</li>
                                <li>Powered by HomeCookt platform</li>
                            </ul>
                        </div>
                    </div>

                    {/* Financial Empowerment */}
                    <div className="service-card">
                        <div className="service-icon">
                            <img src={image63} alt="Financial Empowerment" />
                        </div>
                        <div className="service-content">
                            <h3>Financial Empowerment</h3>
                            <p>Multiple income stream opportunities for adults over 18 years.</p>
                            <ul className="service-points">
                                <li>Digital marketing and affiliate programs</li>
                                <li>Online business development training</li>
                                <li>Investment guidance and portfolio building</li>
                                <li>Passive income stream creation</li>
                                <li>Financial literacy and planning workshops</li>
                                <li>Mentorship and ongoing support</li>
                                <li>E-commerce and dropshipping opportunities</li>
                                <li>Freelancing and skill monetization platforms</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* Existing Services Section - moved to bottom */}
            <div className="parent-container42">
                <div className="info25">
                    <h2>Core Matchmaking Services</h2>
                </div>

                <div className="core-services-grid">
                    {/* Profile Creation */}
                    <div className="service-card">
                        <div className="service-icon">
                            <img src={image31} alt="Profile Creation" />
                        </div>
                        <div className="service-content">
                            <h3>Profile Creation</h3>
                            <p>Create a detailed profile with your preferences, interests, and background to attract potential life partners and increase your chances of finding a compatible match.</p>
                            <ul className="service-points">
                                <li>Personalized Profile Showcase</li>
                                <li>Highlight Your Cultural Roots</li>
                                <li>Enhanced Matchmaking Algorithm</li>
                                <li>Photo verification and authenticity checks</li>
                                <li>Detailed preference matching system</li>
                            </ul>
                        </div>
                    </div>

                    {/* Matchmaking Services */}
                    <div className="service-card">
                        <div className="service-icon">
                            <img src={image32} alt="Matchmaking Services" />
                        </div>
                        <div className="service-content">
                            <h3>Matchmaking Services</h3>
                            <p>Leverage our advanced matchmaking services and let our team of experts curate a personalized list of potential partners based on your preferences and criteria.</p>
                            <ul className="service-points">
                                <li>Exclusive Match Recommendations</li>
                                <li>Professional Expert Assistance</li>
                                <li>Privacy Protection</li>
                                <li>Compatibility scoring and analysis</li>
                                <li>Personalized relationship counseling</li>
                            </ul>
                        </div>
                    </div>

                    {/* Communication Tools */}
                    <div className="service-card">
                        <div className="service-icon">
                            <img src={image33} alt="Communication Tools" />
                        </div>
                        <div className="service-content">
                            <h3>Communication Tools</h3>
                            <p>Use our innovative communication tools, including chat and video call features, to connect with your potential life partner and strengthen your understanding before taking the next step.</p>
                            <ul className="service-points">
                                <li>Instant Messaging and Chat</li>
                                <li>Video Call and Audio Call</li>
                                <li>Safe and Secure Communication</li>
                                <li>Real-time translation support</li>
                                <li>Conversation starters and icebreakers</li>
                            </ul>
                        </div>
                    </div>

                    {/* Wedding Planning Resources */}
                    <div className="service-card">
                        <div className="service-icon">
                            <img src={image34} alt="Wedding Planning Resources" />
                        </div>
                        <div className="service-content">
                            <h3>Wedding Planning Resources</h3>
                            <p>Access our collection of wedding planning resources, including ideas, tips, and inspiration, to make your Global wedding a memorable celebration filled with cultural richness.</p>
                            <ul className="service-points">
                                <li>Inspiring Wedding Ideas</li>
                                <li>Cultural Traditions and Customs</li>
                                <li>Expert Wedding Advice</li>
                                <li>Vendor recommendations and reviews</li>
                                <li>Budget planning and cost estimation tools</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Services;
